<template>
  <div class="cookie-mask">
    <div class="cookie-info">
      <div class="cookie-page">
        <div v-if="cookiePageSwitch">
          <h3 class="cookie-title">{{translations.cookie_settings}}</h3>
          <li class="row settings-list" v-for="(item, index) in cookieSettings" :key="index">
            <div
              v-if="changeable[index]"
              class="col-12 col-lg-12 col-xl-2"
              :class="item+'-btn'"
              @click="changeCookie(index, item)"
            >
              <button type="button">
                <span v-if="item == 'true'">{{translations.off}}</span>
                <span v-else>{{translations.on}}</span>
              </button>
            </div>
            <div v-else class="col-12 col-lg-12 col-xl-2"></div>
            <div class="col-12 col-lg-6 col-xl-3 cookie-mid left">{{index}}</div>
            <div class="col-12 col-lg-12 col-xl-4">{{translations.cookie_descriptions[index]}}</div>
          </li>
        </div>
        <div v-else>
          <h3>{{translations.title}}</h3>
          <div v-html="content"></div>
        </div>
      </div>
      <div class="cookie-buttons">
        <button
          class="col-12 col-md-6"
          type="button"
          @click="eventEmitter('emitChangeBoolean', 'cookiePageSwitch')"
        >
          <span v-if="cookiePageSwitch">{{translations.title}}</span>
          <span v-else>{{translations.cookie_settings}}</span>
        </button>
        <button
          id="policy-readed"
          class="col-12 col-md-6"
          type="button"
          @click="eventEmitter('emitPolicyReaded', 'policyReaded')"
        >
          <span>{{translations.save_and_stay}}</span>
        </button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "fcwpCookieInfo",
  props: ["content", "changeable", "translations", "cookiePageSwitch"],
  data() {
    return {
      cookieSettings: this.listCookies()
    };
  },
  methods: {
    eventEmitter(method, value) {
      this.$root.$emit(method, value);
    },
    listCookies() {
      var cookies = document.cookie;
      cookies = cookies.split("; ");
      var cookieObject = {};
      cookies.forEach(function(item, index) {
        var splitted = item.split("=");
        var cookieName = splitted[0];
        var cookieValue = splitted[1];
        cookieObject[cookieName] = cookieValue;
      });
      return cookieObject;
    },
    changeCookie(name, value) {
      var cookie = require("vue-cookie");
      var newValue;
      if (value == "true") {
        newValue = false;
      } else if (value == "false") {
        newValue = true;
      }
      cookie.set(name, newValue, { expires: "1Y" });
      this.cookieSettings = this.listCookies();
    }
  }
};
</script>


<style scoped lang="scss">
//all in cookie_info.scss
</style>